import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=03d6c746&"
import script from "./GuestBox.vue?vue&type=script&lang=ts&"
export * from "./GuestBox.vue?vue&type=script&lang=ts&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports